import React from 'react';

const HomeFooter = () => {
  return (
    <footer className="home__footer">
      <span className="home__footer-hint">Press ⌘K for options · Press . for terminal</span>
      <a href="https://davidkavanagh.work" target="_blank" rel="noopener noreferrer">Download CV</a>
    </footer>
  );
};

export default HomeFooter;
